import { AxiosInstance } from "axios";
import { merge } from "lodash";
import createAxiosInstance from "./axios";

interface AxiosInstanceConfigureType {
  baseURL: string;
  headers?: object;
}

class ApiClient {
  private axiosClient: AxiosInstance;

  constructor(configure: AxiosInstanceConfigureType) {
    this.axiosClient = createAxiosInstance();

    const { baseURL, headers = {}, ...rest } = configure;

    this.axiosClient.defaults.baseURL = baseURL;
    this.axiosClient.defaults.headers = {
      ...merge(this.axiosClient.defaults.headers, headers),
    };
    this.axiosClient.defaults = {
      ...this.axiosClient.defaults,
      ...rest,
    };
  }

  get client() {
    return this.axiosClient;
  }
}

export default ApiClient;
